import { CheckOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import _ from 'lodash';

import { updateUser } from "../../helpers/userSlice";
import { putData } from "../../services/HomeService";
import { getPathFromHostname, showErrorMessage } from "../../utils";
import { ENTERPRISE_URL } from "../../constants"; 

export default function SelectionComponent({ orgType, verified, step }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user);

  const [activeButton, setActiveButton] = useState(orgType);
  const [showPopUp, setShowPopUp] = useState(false);
  const [countdown, setCountdown] = useState(5);

  const handleOptionClick = (option) => {
    setActiveButton(option);
  };

  useEffect(() => {
    if (orgType) {
      navigate(`/verification?userType=${orgType}&userVerified=${verified}&userStep=${step}`);
    }
  }, [orgType, navigate, verified, step]);

  useEffect(() => {
    let timer;
    if (showPopUp && countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (countdown === 0) {
      window.location.href = `${ENTERPRISE_URL}/verification?userType=${activeButton}&userVerified=${verified}&userStep=${step}`;
      setShowPopUp(false);
    }
    return () => clearTimeout(timer);
  }, [showPopUp, countdown, activeButton, verified, step]);

  const handleButtonClick = async () => {
    if (activeButton) {
      const id = _.get(userData, 'id', '');
      const email = _.get(userData, 'email', '');
      if (!id || !email) return;
      
      const domain = _.get(userData, 'domain', '') || getPathFromHostname('domain');
      const response = await putData(`/users/${id}`, { orgType: activeButton, email, domain: domain });
      if (response.success) {
        dispatch(updateUser({ orgType: activeButton, domain }));
        if (activeButton === 'enterprise') {
          setShowPopUp(true);
          return;
        }
        navigate(`/verification?userType=${activeButton}&userVerified=${verified}&userStep=${step}`);
      } else {
        showErrorMessage(response.message);
      }
    } else {
      alert("Please select where you belong");
    }
  };

  const handleSubmit = () => {
    window.location.href = `${ENTERPRISE_URL}/verification?userType=${activeButton}&userVerified=${verified}&userStep=${step}`;
    setShowPopUp(false);
  };

  const onClose = () => {
    setShowPopUp(false);
    setCountdown(5);
  };

  return (
    <div className='login-welcome-container'>
      <h1>Welcome!</h1>
      <h3>Which one are you?</h3>
      <div className='login-choose-button'>
        <Button className={activeButton === 'vendor' ? 'active' : ''} onClick={() => handleOptionClick('vendor')}>
          <CheckOutlined />Vendor
        </Button>
        <Button className={activeButton === 'enterprise' ? 'active' : ''} onClick={() => handleOptionClick('enterprise')}>
          <CheckOutlined />Enterprise
        </Button>
      </div>
      <div className='login-submit-button'>
        <Button className={activeButton ? 'active' : 'disabled'} disabled={!activeButton} onClick={handleButtonClick}>
          Enter
        </Button>
      </div>
      {showPopUp && (
        <Modal
          open={showPopUp}
          onCancel={onClose}
          footer={null}
          style={{ display: "flex", justifyContent: "center", top: '40%' }}
          className="Dashboard_modal"
        >
          <div className="sp_container">
            <div className="sp_subContainer">
              <div className="sp_text">
                <h1>You are being redirected ...</h1>
                <p>This is not the right platform for Enterprise Login. Redirecting you to enterprise dashboard in {countdown} seconds.</p>
              </div>
            </div>
            <Button onClick={handleSubmit}>
              Redirect Now
            </Button>
          </div>
        </Modal>
      )}
    </div>
  );
}